













































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IActivity, IMineRankInfo, IPageParams, IRank } from "@/types";
import { getInvitationBuyCourseRank, getInvitationCardFollowRank } from "@/api";
enum EStatus {
  opened = "opened",
  closed = "closed"
}
enum ERankType {
  follow = "follow",
  buy = "buy"
}
@Component
export default class Leaderboard extends Vue {
  $refs!: {
    scroll: HTMLElement;
    scrollContent: HTMLElement;
  };
  @Prop({ type: Object, required: true }) activity!: IActivity;
  ERankType = ERankType;
  type: ERankType = ERankType.follow;
  followRank: IRank = {
    mineRankInfo: {} as IMineRankInfo,
    rankUsers: []
  };
  buyRank: IRank = {
    mineRankInfo: {} as IMineRankInfo,
    rankUsers: []
  };
  pageParams: IPageParams = {
    page: 0,
    limit: 10,
    loading: false,
    end: false
  };
  get rank(): IRank {
    let rank!: IRank;
    if (this.type === ERankType.follow) {
      rank = this.followRank;
    } else if (this.type === ERankType.buy) {
      rank = this.buyRank;
    }
    return rank;
  }
  get isShowSwitchTabs(): boolean {
    return !!(
      this.activity.status === EStatus.opened &&
      this.activity.inviteBuyStatus === EStatus.opened
    );
  }
  get isCaizhiActivity() {
    return !!this.activity.isCaizhiActivity;
  }

  @Watch("activity.id", { immediate: true })
  async onActivityChange(actId: number) {
    this.getRank(actId);
  }

  onScroll() {
    const loadHeight =
      this.$refs.scroll.offsetHeight + this.$refs.scroll.scrollTop;
    const contentHeight = this.$refs.scrollContent.offsetHeight;
    if (contentHeight - loadHeight <= 0) {
      this.getRank(this.activity.id);
    }
  }

  async getRank(actId: number) {
    if (this.pageParams.loading || this.pageParams.end) return;
    this.pageParams.loading = true;
    if (this.activity.inviteBuyStatus === EStatus.opened) {
      this.type = ERankType.buy;
      const data = await getInvitationBuyCourseRank(actId, this.pageParams);
      (this.pageParams.page as number)++;
      if (data.invitedUsers.length < (this.pageParams.limit as number)) {
        this.pageParams.end = true;
      }
      this.buyRank.mineRankInfo = data.mineInvitationBuyCourseInfo;
      this.buyRank.rankUsers.push(...data.invitedUsers);
    }
    if (this.activity.status === EStatus.opened) {
      const data = await getInvitationCardFollowRank(actId, this.pageParams);
      (this.pageParams.page as number)++;
      if (data.invitedUsers.length < (this.pageParams.limit as number)) {
        this.pageParams.end = true;
      }
      this.followRank.mineRankInfo = data.mineInvitationCardInfo;
      this.followRank.rankUsers.push(...data.invitedUsers);
    }
    this.pageParams.loading = false;
  }
  toMy() {
    this.$router.push({
      name: "my",
      params: { actId: String(this.activity.id) }
    });
  }
}
